import ApiTokens from 'features/admin/accountSettings/apiTokens'
import Integrations from 'features/admin/accountSettings/integrations'
import RevenueReporting from 'features/admin/accountSettings/revenueReporting'

import { TabbedNavRoute } from './interfaces'
import {
  accountsTokensPaths,
  integrationSettingsPath,
  revenueSettingsPath,
} from './paths'

export const integrationsSettingsRoute: TabbedNavRoute = {
  key: 'admin-account-integrations',
  name: 'Integrations',
  to: integrationSettingsPath,
  component: Integrations,
  accessFlags: {
    flags: ['showContentIntegrations'],
    type: 'hide',
  },
}

export const revenueSettingsRoute: TabbedNavRoute = {
  key: 'admin-account-revenue',
  name: 'Revenue reporting',
  to: revenueSettingsPath,
  component: RevenueReporting,
  accessFlags: {
    flags: ['showRevenueReporting'],
    type: 'hide',
  },
}

export const accountsTokensRoute: TabbedNavRoute = {
  key: 'admin-accounts-tokens',
  name: 'API Tokens',
  to: accountsTokensPaths,
  component: ApiTokens,
}
export const accountSettingsSubroutes: TabbedNavRoute[] = [
  integrationsSettingsRoute,
  revenueSettingsRoute,
  accountsTokensRoute,
]
